import { GitSideBand } from './GitSideBand';

export async function parsePayload(payload) {
  return GitSideBand.demux(payload);
}
